import { useEffect, useRef } from 'react';
import { useDebounce } from 'react-use';

export function useOnChange(cb: () => void, deps: any[]) {
  const changesCount = useRef(0);

  useEffect(() => {
    if (changesCount?.current >= 0) {
      cb();
    }
    changesCount.current += 1;
  }, [deps]);

  return changesCount.current;
}

export function useOnChangeDebounced(cb: () => void, ms: number, deps: any[]) {
  const changesCount = useRef(0);

  useDebounce(
    () => {
      if (changesCount?.current >= 0) {
        cb();
      }
      changesCount.current += 1;
    },
    ms,
    [deps],
  );

  return changesCount.current;
}
